import { Field, FieldOperations, OpsCategories, SqlOperation, TableI } from "../../Types";
import { nanoid } from "@reduxjs/toolkit";


const fieldOperations: FieldOperations = {
    id: [...OpsCategories.eq, ...OpsCategories.range, ...OpsCategories.in,],
    dt: [...OpsCategories.range],
    msisdn: [...OpsCategories.eq, ...OpsCategories.like, ...OpsCategories.in,],
    finished_time: [...OpsCategories.range, ...OpsCategories.null],
    user_id: [...OpsCategories.eq],
    survey_id: [...OpsCategories.eq],
};

export function survey287DefFilters() {
    return [
        {
            nanoid: nanoid(),
            field: 'finished_time',
            type: 'datetime',
            filterOp: SqlOperation.IS_NOT_NULL,
            locked: true,
            value: ''
        }
    ]
}

export const SurveyTable: TableI = {
    backend: "/287/",
    title: {
        ua: "Опитування",
    },
    pk: 'id',
    defaultOrderedBy: "finished_time",
    defaultOrderedWay: "DESC",
    defaultPerPage: 20,
    orderByFields: {
        "finished_time": { ua: "Пройдено", ru: "Дата" },
    },
    fieldOperations: fieldOperations,
    defaultFilters: 'survey287DefFilters',
    fields: [
        {
            key: "n",
            inline: true,
            title: { ua: "№", ru: "№" }, type: "number",
            applyTransform: true
        }, {
            key: "id",
            detailed: true,
            title: { ua: "ID", ru: "№" },
            type: "number",
            applyTransform: true
        },
        {
            key: "user_id", type: 'number',
            applyTransform: true,
            detailed: true, inline: true, title: { ua: "ID користувача", ru: "Телефон" }
        },
        {
            key: "msisdn", type: 'tel',
            applyTransform: true,
            headAlign: "left",
            detailed: true,
            inline: true,
            title: { ua: "Телефон" },
        },
        {
            key: "survey_id", type: 'number',
            applyTransform: true,
            detailed: true, inline: true, title: { ua: "ID опитування", ru: "Телефон" }
        },
        {
            key: "finished_time",
            title: { ua: "Пройдено", ru: "Дата" },
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },
        {
            key: "result",
            type: 'json',
            applyTransform: true,
            detailed: true, inline: false,
            editable: false,
            title: { ua: "Результат", }
        },
        {
            key: "dt",
            title: { ua: "Створено", ru: "Дата" },
            type: "datetime",
            datetimeFormat: "DD MMMM YYYY HH:mm",
            applyTransform: true,
            detailed: true,
            inline: true,
        },

    ] as Field[]
}


